import styled from "styled-components";

const List = styled.ul`
  padding: 0;
  margin: 0;
  text-decoration: none;
  list-style: none;
`;

export default List; 